var $1d7c2ea2c75b28d6$exports = {};
$1d7c2ea2c75b28d6$exports = {
    "help": `Aide`,
    "info": `Informations`
};


export {$1d7c2ea2c75b28d6$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
